'use client';

import {
  UserCog,
  ShoppingBasket,
  KeyRound,
  HandPlatter,
  Warehouse,
  Layers,
  Layers2,
  CircleDollarSign,
  Car,
  UsersRound,
  ShieldAlert,
  Layout
} from 'lucide-react';
import { SidebarDesktop } from './sidebar-desktop';
import { SidebarItems } from '@/types';
import { useMediaQuery } from 'usehooks-ts';
import { SidebarMobile } from './sidebar-mobile';

const sidebarItems: SidebarItems = {
  links: [
    {
      label: 'Dashboard',
      href: '/admin/dashboard',
      icon: Layout,
    },
    {
      label: 'Assets',
      href: '/admin/assets',
      icon: Car,
      allowedPermissions: ["asset-create", "asset-delete", "asset-edit", "asset-list"]
    },
    {
      label: 'Billings',
      href: '/admin/billings',
      icon: CircleDollarSign,
      allowedPermissions: ["billings-list", "billings-create", "billings-edit", "billings-delete"]
    },
    {
      label: 'Beacons',
      href: '/admin/beacons',
      icon: Layers2,
      allowedPermissions: ["beacon-list", "beacon-create", "beacon-edit", "beacon-delete"]
    },
    {
      label: 'BeaconsStores',
      href: '/admin/beaconsStores',
      icon: Warehouse,
      allowedPermissions: ["beacon-store-list", "beacon-store-create", " beacon-store-edit", "beacon-store-delete"]
    },
    {
      label: 'BeaconsTypes',
      href: '/admin/beaconsTypes',
      icon: Layers,
      allowedPermissions: ["beacon-types-list", "beacon-types-create", "beacon-types-edit", "beacon-types-delete"]
    },
    {
      label: 'Customers',
      href: '/admin/customers',
      icon: HandPlatter,
      allowedPermissions: ["customer-list", "customer-create", "customer-edit", "customer-delete"]
    },
    {
      href: '/admin/products',
      icon: ShoppingBasket,
      label: 'Products',
      allowedPermissions: ["product-list", "product-create", "product-edit", "product-delete"]
    },
    {
      href: '/admin/technicians',
      icon: UserCog,
      label: 'Technicians',
      allowedPermissions: ["technician-list", "technician-create", "technician-edit", "technician-delete"]
    },
    {
      href: '/admin/users',
      icon: UsersRound,
      label: 'Users',
      allowedPermissions: ["user-list", "user-create", "user-edit", "user-delete"]
    },
    {
      href: '/admin/roles',
      icon: ShieldAlert,
      label: 'Roles',
      allowedPermissions: ["role-list", " role-create ", "role-edit", "role-delete"]
    },
    {
      href: '/admin/Permissions',
      icon: KeyRound,
      label: 'Permissions',
      allowedPermissions: ["permission-list", "permission-create", "permission-edit", "permission-delete"]
    }
  ],
  extras: (
    <div className='flex flex-col gap-2'>
      {/* <SidebarButton icon={MoreHorizontal} className='w-full'>
        More
      </SidebarButton> */}
      {/* <SidebarButton
        className='w-full justify-center text-white'
        variant='default'
      >
        Tweet
      </SidebarButton> */}
    </div>
  ),
};



export function Sidebar() {
  const isDesktop = useMediaQuery('(min-width: 640px)', {
    initializeWithValue: false,
  });

  if (isDesktop) {
    return <SidebarDesktop sidebarItems={sidebarItems} />;
  }

  return <SidebarMobile sidebarItems={sidebarItems} />;
}
